import { Variants } from "framer-motion";

export const heroVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: (custom: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: custom * 0.2,
      duration: 0.8,
      ease: "easeOut",
    },
  }),
};

export const cardVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: (custom: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.6 + custom * 0.15,
      duration: 0.6,
      ease: "easeOut",
    },
  }),
};

export const dotVariants: Variants = {
  animate: {
    y: ["0%", "-50%", "0%"],
    transition: {
      duration: 0.6,
      ease: "easeInOut",
      repeat: Infinity,
    },
  },
};